import React, { useState , useRef, useEffect} from 'react'
import BreadCrames from '../component/BreadCrames'
import "react-datepicker/dist/react-datepicker.css";
import { StandaloneSearchBox, LoadScript, Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from 'react-redux';
import { IMAGE } from '../utils/Theme';
import Loader from '../utils/Loader';
import ApiConnection from '../utils/ApiConnection';
import { sidebarAction } from '../redux/SidebarSlice';

const AddTrip = () => {
    const [loading, setloading] = useState(false)
    const [customerList, setcustomerList] = useState([])
    const [pickupDate, setpickupDate] = useState(new Date());
    const [pickupTime, setpickupTime] = useState(new Date());
    const [carttype, setcarttype] = useState('Sedan')
    const [pickuplocation, setpickuplocation] = useState('')
    const [droplocation, setdroplocation] = useState('')
    const [pickuplat, setpickuplat] = useState('')
    const [pickuplng, setpickuplng] = useState('')
    const [droplat, setdroplat] = useState('')
    const [droplng, setdroplng] = useState('')
    const [fname, setfname] = useState("")
    const [lname, setlname] = useState("")
    const [email, setemail] = useState("")
    const [phone, setphone] = useState("")
    const [stoploclist, setstoploclist] = useState([
        {
            address:'',
        }
    ])
    const [isdroplist, setisdroplist] = useState(false)
    const [customertype, setcustomertype] = useState('old')
    const [CustomerId, setCustomerId] = useState('')
    const [fare, setfare] = useState('')
    const inputRef = useRef()
    const inputRef1 = useRef()
    const inputRef2 = useRef()

    const dispatch = useDispatch()

      const handleplacesChanged = () =>{

        const [place] = inputRef.current.getPlaces();

        if(place){
           
           var _address = place.formatted_address;
        // var _country = "";
        // var _city = "";
        // var _state = "";
        // var _zipcode = ""
        var _lat = place.geometry.location.lat()
        var _lng = place.geometry.location.lng()
        setpickuplat(_lat)
        setpickuplng(_lng)
        setpickuplocation(_address)
        // for (const component of place.address_components){
        //   const addressType = component.types[0]
        //   console.log(addressType)
        //   if(addressType == "administrative_area_level_3"){
        //     _city = component.long_name
        //   } 
        //   if(addressType == "administrative_area_level_1"){
        //     _state = component.long_name
        //   }
        //   if(addressType == "country"){
        //     _country = component.long_name
        //   }
        //   if(addressType == "postal_code"){
        //     _zipcode = component.long_name
        //   }
        // }
        }

      }

      const handleplacesChangedone = () =>{

        const [place] = inputRef1.current.getPlaces();

        if(place){
            console.log(place)
           var _address = place.formatted_address;
           var _lat = place.geometry.location.lat()
           var _lng = place.geometry.location.lng()
           setdroplat(_lat)
           setdroplng(_lng)
           setdroplocation(_address)

        }

      }

      const AddHandle = () =>{

        let obj = {
            address:'',
        }

        setstoploclist([...stoploclist, obj])

      }

      const RemoveHandle = (indx) =>{

        const rows = [...stoploclist];
        rows.splice(indx, 1);
        setstoploclist(rows);
      }

      const handledropChanged = (index) =>{

        const [place] = inputRef2.current.getPlaces();

        if(place){
          
           var _address = place.formatted_address;
           let obj = {
            address:_address, 
          }
          
           const rowsInput = [...stoploclist];
          rowsInput[index] = obj;

          setstoploclist(rowsInput);

        }

      }

      const Getdata = async () =>{

        setloading(true)

        try {

            const response = await ApiConnection.get('trips/customer')
            setloading(false)
            if(response?.status === 200) {
                setcustomerList(response?.data?.data?.list)
            }

        } catch (e){  setloading(false)}

    }


      useEffect(()=>{
        Getdata()
        dispatch(sidebarAction(false)) 
      },[])


      const SubmitHandle = async () =>{

        if(customertype == 'old'){
            if(CustomerId == ''){
                toast.error('Customer is required')
            } else if(pickuplocation == ''){
                toast.error('Pickup location is required')
            } else if(droplocation == ''){
                toast.error('Drop location is required')
            } else if(fare == ''){
                toast.error('Fare is required')
            }     else {

    
                setloading(true)
        
                     var FormData = require('form-data');
                    var data = new FormData();
                    data.append('customer_type', customertype);
                    if(customertype == 'old'){
                        data.append('customer', Number(CustomerId));
                    } else {
                        data.append("first_name", fname);
                        data.append("last_name", lname);
                        data.append("email", email);
                        data.append("phone",phone);
                    }
                    
                    data.append("date", moment(pickupDate).format('YYYY-MM-DD'));
                    data.append("time", moment(pickupTime).format('HH:mm:ss'));
                    data.append("pickup_location", pickuplocation);
                    data.append("pickup_lat", pickuplat);
                    data.append("pickup_long", pickuplng);
                    data.append("destination", droplocation);
                    data.append("drop_lat", droplat);
                    data.append("drop_long", droplng);
                    data.append("car_type", carttype);
                    data.append("estimated_fare", fare);
                    data.append("country_code", '+91');
                    
        
                    {stoploclist.map((item)=>{
                        data.append("stop[]", item?.address);
                    })}
        
                try{
        
                    const response = await ApiConnection.post('/trips', data)
                    setloading(false)
                    if(response?.status === 200) {
                      toast.success(response?.data?.message)
                    }
        
        
                } catch(e){  
                    setloading(false)
                    if(e.response?.status === 422){
                        toast.error(e.response?.data?.message)
                    }
        
                }
            }
        }
        else if(customertype == 'new'){
            if(fname == ''){
                toast.error('First name is required')
            } else if(lname == ''){
                toast.error('Last name is required')
            }else  if(email == ''){
                toast.error('Email is required')
            }else if(phone == ''){
                toast.error('Phone is required')
            }else if(pickuplocation == ''){
                toast.error('Pickup location is required')
            } else if(droplocation == ''){
                toast.error('Drop location is required')
            } else if(fare == ''){
                toast.error('Fare is required')
            }     else {

    
                setloading(true)
        
                     var FormData = require('form-data');
                    var data = new FormData();
                    data.append('customer_type', customertype);
                    if(customertype == 'old'){
                        data.append('customer', Number(CustomerId));
                    } else {
                        data.append("first_name", fname);
                        data.append("last_name", lname);
                        data.append("email", email);
                        data.append("phone",phone);
                    }
                    
                    data.append("date", moment(pickupDate).format('YYYY-MM-DD'));
                    data.append("time", moment(pickupTime).format('HH:mm:ss'));
                    data.append("pickup_location", pickuplocation);
                    data.append("pickup_lat", pickuplat);
                    data.append("pickup_long", pickuplng);
                    data.append("destination", droplocation);
                    data.append("drop_lat", droplat);
                    data.append("drop_long", droplng);
                    data.append("car_type", carttype);
                    data.append("estimated_fare", fare);
                    data.append("country_code", '+91');
                    
        
                    {stoploclist.map((item)=>{
                        data.append("stop[]", item?.address);
                    })}
        
                try{
        
                    const response = await ApiConnection.post('/trips', data)
                    setloading(false)
                    if(response?.status === 200) {
                      toast.success(response?.data?.message)
                    }
        
        
                } catch(e){  
                    setloading(false)
                    if(e.response?.status === 422){
                        toast.error(e.response?.data?.message)
                    }
        
                }
            }
        }  
        
     

      }

  return (
    <>
     {loading && <Loader/>}
       <LoadScript googleMapsApiKey="AIzaSyBrRtkwvBcSh3_uISG8CVAX2IqykHdQEP4"
    libraries={["places"]}>
    <BreadCrames page="Trip Management" />
    <div className='px-4'>
        <div className='card'>
            <div className='card-header'>
               Add Trip
            </div>
            <div className='card-body'>
            <div className='row'>
            <div className='col-lg-12'>
                <div className='form-group'>
                    <input type='radio' name="cutomer" value="old" onChange={(e)=>setcustomertype(e.target.value)} checked={customertype == 'old' ? true : false}/> Existing Customer &nbsp; &nbsp;
                    <input type='radio'  name="cutomer" value="new" onChange={(e)=>setcustomertype(e.target.value)} checked={customertype == 'new' ? true : false} /> New Customer
                </div>
            </div>
            {customertype == 'old' &&
            <div className='col-lg-12'>
                <div className='form-group'>
                  <label>Select Customer</label>
                  <select className='form-control' value={CustomerId} onChange={(e)=>setCustomerId(e.target.value)}>
                    <option>--Select--</option>
                    {
                        customerList&&customerList.map((item, i)=>{
                            return (
                                <option value={item?.id}>{item?.first_name} {item?.last_name}</option>
                            )
                        })
                    }
                  </select>
                </div>
            </div>
}
{customertype == 'new' &&
            <div className='col-lg-12'>
                <div className='row'>
                <div className='col-lg-6'>
            <div className='form-group'>
                <label>First Name</label>
                <input type="text" className="form-control" placeholder="First Name"
                value={fname}
                onChange={(e)=>setfname(e.target.value)}
                />
            </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>Last Name</label>
                <input type="text" className="form-control" placeholder="Last Name"
                value={lname}
                onChange={(e)=>setlname(e.target.value)}
                />
            </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>Email</label>
                <input type="email" className="form-control" placeholder="Email"
                value={email}
                onChange={(e)=>setemail(e.target.value)}
                />
            </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                <label>Phone Number</label>
                <input type="email" className="form-control" placeholder="Phone Number"
                value={phone}
                onChange={(e)=>setphone(e.target.value)}
                onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  maxLength="10"
                />
            </div>
            </div>
                </div>
            </div>
}
            <div className='col-lg-6'>
                <div className='form-group'>
                    <label className='d-block'>PickUp Date:</label>
                    <DatePicker className='form-control' selected={pickupDate} onChange={(date) => setpickupDate(date)} />
                </div>
            </div>
            <div className='col-lg-6'>
                <div className='form-group'>
                    <label className='d-block'>PickUp Time:</label>
                    <DatePicker className='form-control'
                     selected={pickupTime} onChange={(date) => setpickupTime(date)}
                     showTimeSelect
                     showTimeSelectOnly
                     timeIntervals={15}
                     timeCaption="Time"
                     dateFormat="h:mm aa"
                     />
                
                </div>
            </div>
            <div className='col-lg-12'>
                <div className='form-group address-field'>
                    <label>Select Pickup Location:</label>
                        <StandaloneSearchBox
                        onLoad={ref =>(inputRef.current = ref)}
                        onPlacesChanged={handleplacesChanged}
                        className="address-auto"
                        >
                             <input
                            type="text"
                            placeholder="Enter Address"
                        className="form-control"
                        />
                        </StandaloneSearchBox>
           

                </div>
            </div>
            {/* <div className='col-lg-3'>
                <div className='ride-form-field'>
                    <h6>Choose From Map</h6>
                </div>
            </div> */}
            <div className='col-lg-6'>
                <div className='form-group'>
                    <label>Select Car Type:</label>
                    <ul className='cart_type_list'>
                        <li>
                            <button className={carttype == 'Sedan' ? 'car-type active' : 'car-type'}  onClick={()=>setcarttype('Sedan')}>
                                <img src={IMAGE.seden} alt="calender" />
                                <br></br>
                                Sedan
                            </button>
                        </li>
                        <li>
                            <button className={carttype == 'Deluxe' ? 'car-type active' : 'car-type'}  onClick={()=>setcarttype('Deluxe')}>
                                <img src={IMAGE.delux} alt="calender" />
                                <br></br>
                                Deluxe
                            </button>
                        </li>
                        <li>
                            <button className={carttype == 'Custom' ? 'car-type active' : 'car-type'}  onClick={()=>setcarttype('Custom')}>
                                <img src={IMAGE.custom} alt="calender" />
                                <br></br>
                                Custom
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div className='col-lg-6'>
            <div className='form-group'>
                    <label className='d-block'>Estimated Fare:</label>
                    <input type='text' className='form-control'
                     value={fare}
                     onChange={(e)=>setfare(e.target.value)}
                    />
                </div>
            </div>
           
            <div className='col-lg-12'>
                <div className='form-group address-field'>
                    <label>Select Destination:</label>
                    <StandaloneSearchBox
                        onLoad={ref =>(inputRef1.current = ref)}
                        onPlacesChanged={handleplacesChangedone}
                        className="address-auto"
                        >
                             <input
                            type="text"
                            placeholder="Enter Address"
                        className="form-control"
                        />
                        </StandaloneSearchBox>
                 
                </div>
            </div>
            {/* <div className='col-lg-2'>
                <div className='ride-form-field'>
                    <h6>Choose From Map</h6>
                </div>
            </div> */}
    
        </div>
        <div className='ride-form-field'>
                    <h3>Add Stop(s) &nbsp;  &nbsp; 
                        {isdroplist ? 
                        <button className='plusbtn' onClick={()=>setisdroplist(false)}><img src={IMAGE.cross_icon} /></button>
                       
                         :
                         <button className='plusbtn' onClick={()=>setisdroplist(true)}><img src={IMAGE.plus_icon} /></button>
                    }
                        
                    </h3>
          </div> 

{isdroplist && 
<div className='drop-listed'>

        <div className='stop-list'>
            <div className='stop-list-lft'>
               <img src={IMAGE.pick_icon} alt='' />
            </div>
            <div className='stop-list-mid'>
               <input type='text' className='form-control' placeholder='Pick up' value={pickuplocation} />
            </div>
            <div className='stop-list-rht'>
               
            </div>
        </div>

        {stoploclist.map((item, index)=>{


            return (
                <div className='stop-list'>
            <div className='stop-list-lft'>
             <span>{index + 1}</span>
            </div>
            <div className='stop-list-mid'>
            <StandaloneSearchBox
                        onLoad={ref =>(inputRef2.current = ref)}
                        onPlacesChanged={()=>handledropChanged(index)}
                        className="address-auto"
                        >
                             <input
                            type="text"
                            placeholder="Enter Address"
                        className="form-control"
                        />
                        </StandaloneSearchBox>
                 
            </div>
            <div className='stop-list-rht'>
                {index === 0 ?
               <button onClick={AddHandle}>
                    <img src={IMAGE.plus_icon} alt="calender" />
               </button>
               :
           
               <button onClick={()=>RemoveHandle(index)}>
                    <img src={IMAGE.cross_icon} alt="calender" />
               </button>
        }
            </div>
        </div>
            )
        })}


        <div className='stop-list'>
            <div className='stop-list-lft'>
            <img src={IMAGE.location_fill} alt='' />
            </div>
            <div className='stop-list-mid'>
               <input type='text' className='form-control' placeholder='Drop' value={droplocation} />
            </div>
            <div className='stop-list-rht'>
          
            </div>
        </div>
        </div>
}
<div className='text-center mt-5'>
            <button className='btn btn-primary' onClick={SubmitHandle}>Book Now</button>
        </div>
            </div>
        </div>
    </div>
    </LoadScript>
</>
  )
}

export default AddTrip